      if (window.jQuery) {
      	jQuery( document ).ready(function() {
      		if (jQuery(window).width() > 700) {
		     excerptHeight();
		 	};
		});
		jQuery(window).on('resize', function(){
			if (jQuery(window).width() > 700) {
				excerptHeight();
			}
		});
        let $ = window.jQuery;
        function excerptHeight(){
          $( "section[data-section-type='featured-collection']" ).each(function( index ) {
			    // Get an array of all element heights
				  var elementHeights = $(this).find('.excerpt').map(function() {
				    return $(this).height();
				  }).get();

				  // Math.max takes a variable number of arguments
				  // `apply` is equivalent to passing each height as an argument
				  var maxHeight = Math.max.apply(null, elementHeights);

				  // Set each height to the max height
				  $(this).find('.excerpt').css('min-height' , maxHeight);
			});
      };



    }

